var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('van-image',{attrs:{"width":"100%","fit":"fill","src":require('../assets/bg@2x.png')}}),_c('van-button',{staticStyle:{"width":"80%","height":"34pt","margin":"32pt"},attrs:{"round":"","type":"info"},on:{"click":_vm.go}},[_vm._v("Make money now")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }